<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js"


export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  data: function() {
    return {
      userCanJoinContest: null
    };
  },
  mounted() {
    Fandom.ajax({
      method: "POST",
      url: "/api/v5/get_ugc_video_contest_content",
      data: { },
      success: (data) => {
        this.userCanJoinContest = data.success ? false : true;
      },
      error: (xhr, ajaxOptions, thrownError) => {}
    });
  },
  methods: {},
  computed: {

  }
}

</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" >
    <div v-if="userCanJoinContest" ugc-contest-header class="w-100 py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <div v-html="content.description"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="userCanJoinContest === true" ugc-contest-upload-form class="w-100 bg-kenwood-light-grey py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <generic-form :content="content" :opt-container-content="containerContent"></generic-form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="userCanJoinContest === false && content.already_joined_text" ugc-contest-upload-form class="w-100 bg-kenwood-light-grey py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <div v-html="content.already_joined_text"></div>
          </div>
        </div>
      </div>
    </div>
    <div ugc-contest-further-info class="w-100 py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <div v-html="content.further_info"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>


</style>
